// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vJy3","importantInfo":"styles_importantInfo__3P30J"};